// extracted by mini-css-extract-plugin
export default {"container":"CabinGrades_container__o+vGv","accordions":"CabinGrades_accordions__pHPbE"};